import { plPL } from '@material-ui/core/locale';
import { createTheme, StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import React, { createContext, useState } from 'react';
import { setProperty } from 'utils/helper';

const defaultState = {
	theme: {
		typography: {
			// In Chinese and Japanese the characters are usually larger,
			// so a smaller fontsize may be appropriate.
			fontSize: 14,
			fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif'
		},
		overrides: {
			MuiTableCell: {
				root: {
					fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
					fontSize: '1rem',
				}
			},
			MuiTablePagination: {
				select: {
					fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
					fontSize: '1rem',
				},
			},
			MuiTypography: {
				root: {
					'&.MuiTypography-body2': {
						fontFamily: '"Segoe UI", "ui-sans-serif", sans-serif',
						fontSize: '1rem',
					},
				},
			},
			MuiTooltip: {
				popper: {
				}
			},
			MuiPopover: {
				root: {
				}
			}
		},
		palette: {
			primary: { main: '#006BFF' },
			secondary: { main: '#0A9E50' }
		},
	},
	setTheme: () => {}
};

const Context = createContext(defaultState);

function ThemeProvider({ children }) {
	const [theme, updateTheme] = useState(createTheme(defaultState.theme, plPL));

	const setTheme = object => {
		updateTheme(createTheme(object));
	};

	const setPrimaryColor = value => {
		setProperty('--color-primary', value);

		updateTheme(createTheme({
			...defaultState.theme,
			palette: {
				...defaultState.theme.palette,
				primary: { main: value }
			}
		}));
	};

	return (
		<Context.Provider
			value={{
				theme,
				setTheme,
				setPrimaryColor
			}}
		>
			<MuiThemeProvider theme={theme}>
				<StylesProvider injectFirst>
					{children}
				</StylesProvider>
			</MuiThemeProvider>
		</Context.Provider>
	);
}

export { ThemeProvider };

export default Context;
